import React from 'react';

interface StatusDotProps {
  color: 'green' | 'yellow' | 'gray' | 'red' | 'blue';
  size?: 'sm' | 'md' | 'lg';
  pulse?: boolean;
  label?: string;
}

const sizeMap = { sm: 'w-2 h-2', md: 'w-2.5 h-2.5', lg: 'w-3 h-3' };
const colorMap = {
  green: 'bg-green-500',
  yellow: 'bg-yellow-500',
  gray: 'bg-gray-300',
  red: 'bg-red-500',
  blue: 'bg-blue-500'
};

export default function StatusDot({ color, size = 'md', pulse = false, label }: StatusDotProps) {
  return (
    <span className="inline-flex items-center gap-1.5">
      <span className={`inline-block rounded-full ${sizeMap[size]} ${colorMap[color]} ${pulse && color === 'red' ? 'animate-pulse' : ''}`} />
      {label && <span className="text-xs text-gray-600">{label}</span>}
    </span>
  );
}
